import { render, staticRenderFns } from "./DevBpbjWarehousingRecordList.vue?vue&type=template&id=5ed5060e&scoped=true&"
import script from "./DevBpbjWarehousingRecordList.vue?vue&type=script&lang=js&"
export * from "./DevBpbjWarehousingRecordList.vue?vue&type=script&lang=js&"
import style0 from "./DevBpbjWarehousingRecordList.vue?vue&type=style&index=0&id=5ed5060e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed5060e",
  null
  
)

export default component.exports